module.exports = __webpack_public_path__ + "fonts/Inter-100-greek25.4a4b49c.woff2";